import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, Protected } from "./lib/auth";
import { MarketingLayout } from "./components/marketing/Layout";
import Home from "./pages/marketing/Home";
import GenericPage from "./pages/marketing/GenericPage";
import { PAGES } from "./pages/marketing/content";
import { Pricing, ApiReference, Changelog, StatusPage, Contact, IntegrationsPublic } from "./pages/marketing/BusinessPages";
import { Login, Signup, Forgot, Reset, Onboarding } from "./pages/AuthPages";
import AppShell from "./app/AppShell";
import Overview from "./app/Overview";
import InboxPage from "./app/Inbox";
import Contacts, { ContactDetail } from "./app/Contacts";
import Agents, { AgentWizard, AgentDetail } from "./app/Agents";
import Knowledge from "./app/Knowledge";
import Automations, { WorkflowEditor } from "./app/Automations";
import { Sending, Templates, Domains, Inbound, Logs, Events, Suppressions } from "./app/Email";
import { ApiKeys, Webhooks, Sdks } from "./app/Developer";
import { Analytics, AiQuality, Usage } from "./app/Insights";
import { Integrations, Team, Billing, SettingsPage } from "./app/Admin";
import TemplateDesigner from "./app/TemplateDesigner";
import BrandKit from "./app/BrandKit";
import GoLive from "./app/GoLive";

const M = (el) => <MarketingLayout>{el}</MarketingLayout>;

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="bottom-right" richColors closeButton />
        <Routes>
          <Route path="/" element={M(<Home />)} />
          {Object.keys(PAGES).map((p) => <Route key={p} path={p} element={M(<GenericPage />)} />)}
          <Route path="/pricing" element={M(<Pricing />)} />
          <Route path="/docs/api-reference" element={M(<ApiReference />)} />
          <Route path="/changelog" element={M(<Changelog />)} />
          <Route path="/status" element={M(<StatusPage />)} />
          <Route path="/contact" element={M(<Contact />)} />
          <Route path="/integrations" element={M(<IntegrationsPublic />)} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<Forgot />} />
          <Route path="/reset-password" element={<Reset />} />
          <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
          <Route path="/app" element={<Protected><AppShell /></Protected>}>
            <Route index element={<Overview />} />
            <Route path="inbox" element={<InboxPage />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="contacts/:id" element={<ContactDetail />} />
            <Route path="agents" element={<Agents />} />
            <Route path="agents/new" element={<AgentWizard />} />
            <Route path="agents/:id" element={<AgentDetail />} />
            <Route path="automations" element={<Automations />} />
            <Route path="automations/:id" element={<WorkflowEditor />} />
            <Route path="knowledge" element={<Knowledge />} />
            <Route path="email/sending" element={<Sending />} />
            <Route path="email/templates" element={<Templates />} />
            <Route path="email/templates/:id" element={<TemplateDesigner />} />
            <Route path="email/brand" element={<BrandKit />} />
            <Route path="email/setup" element={<GoLive />} />
            <Route path="email/domains" element={<Domains />} />
            <Route path="email/inbound" element={<Inbound />} />
            <Route path="email/logs" element={<Logs />} />
            <Route path="email/events" element={<Events />} />
            <Route path="email/suppressions" element={<Suppressions />} />
            <Route path="developer/api-keys" element={<ApiKeys />} />
            <Route path="developer/webhooks" element={<Webhooks />} />
            <Route path="developer/sdks" element={<Sdks />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="analytics/ai-quality" element={<AiQuality />} />
            <Route path="analytics/usage" element={<Usage />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="team" element={<Team />} />
            <Route path="billing" element={<Billing />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
